import { canUseDOM } from 'exenv';
import React from 'react';
import { OverlayTrigger } from 'react-bootstrap';
import type { OverlayTriggerProps } from 'react-bootstrap/lib/OverlayTrigger';
import { dropdownPopperConfig } from '../../../helpers/ui/PopperJsHelper';

type Props = Pick<
  OverlayTriggerProps,
  'overlay' | 'show' | 'onToggle' | 'container' | 'children'
> & {
  /**
   * A reference to the overlay container.
   */
  overlayRef: React.RefObject<HTMLElement>;
};

/**
 * Tag Editor Overlay Trigger.
 *
 * @author Willi Hyde
 */
const TagEditorOverlayTrigger: React.FC<React.PropsWithChildren<Props>> = ({
  overlay,
  show,
  onToggle,
  container,
  children,
  overlayRef
}) => {
  /**
   * Determines the placement of a hover card based on the position of the tag selector
   * relative to the viewport's vertical center.
   *
   * @returns {'top' | 'bottom'} - Returns 'top' if the tag selector is positioned
   * above the vertical midpoint of the viewport, otherwise returns 'bottom'.
   */
  function getHoverCardPlacement(): 'top-start' | 'bottom-start' {
    return canUseDOM && overlayRef.current?.getBoundingClientRect().y > window?.innerHeight / 2
      ? 'top-start'
      : 'bottom-start';
  }

  return (
    <OverlayTrigger
      trigger={['click']}
      overlay={overlay}
      placement={getHoverCardPlacement()}
      rootClose
      show={show}
      onToggle={onToggle}
      container={container}
      popperConfig={dropdownPopperConfig}
      flip
    >
      {children}
    </OverlayTrigger>
  );
};

export default TagEditorOverlayTrigger;
